import { ReactNode } from 'react';
import { useHasPermission } from '@/hooks/usePermission';

interface Props {
  name: string;
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Inline permission gate: renders children when the current user has the named
 * permission, otherwise renders the fallback (default null). Use for action
 * affordances inside a page (buttons, menu items) rather than route entry --
 * for routes use RequirePermission. Backend @PreAuthorize is still the source
 * of truth; this just hides chrome the user can't operate.
 */
export function Can({ name, fallback = null, children }: Props) {
  const allowed = useHasPermission(name);
  return <>{allowed ? children : fallback}</>;
}
